<template>
  <div class="index">
    <div class="index-header">
      <el-form :model="form" :inline="true" label-width="110px">
        <div class="input-box">
          <div>
            <label style="margin:5px 10px 0 30px;">地区：</label>
          </div>
          <div style="margin-bottom:10px">
            <Area   :value="area_data"
                :diss="dis"
                :arr="arrPlace2"
                @getPlace="getPlace2"/>
          </div>
          <div>
            <el-form-item label="统计开始时间：">
              <el-date-picker
                style="width:193px;"
                v-model="form.startTime"
                value-format="timestamp"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="统计结束时间：">
              <el-date-picker
                style="width:193px;"
                v-model="form.endTime"
                value-format="timestamp"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </div>
          <div>
            <el-form-item>
              <el-button type="primary"
                     @click=" $data.paging_data.pageSize = $data.paging_data.total = 1 ,
                    Filter_file({api:`${api}/report`,data:form,callback:_d => tableData = _d })"
                     icon="el-icon-search">查询</el-button>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
    <div class="edit">
        <el-button v-if="showBtn[5].isShow" type="primary" v-loading.fullscreen.lock="lodaingTime" @click="Filter_export(`${api}/export`,form)" icon="el-icon-document-remove">导出数据</el-button>
    </div>
    <div class="table">
      <el-table
        :data="tableData"
        border
        max-height="550"
        @selection-change="handleSelectionChange"
        style="width: 99.9%">
        <el-table-column
          prop="areaName"
          label="行政区划"
          align="center">
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="补贴金额（元）"
          align="center">
          <el-table-column
            show-overflow-tooltip
            v-for="item in baseInfo1"
            :key="item.key"
            :prop="item.key"
            :label="item.value"
            align="center">
          </el-table-column>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="补贴人数"
          align="center">
          <el-table-column
            show-overflow-tooltip
            v-for="item in baseInfo2"
            :key="item.key"
            :prop="item.key"
            :label="item.value"
            align="center">
          </el-table-column>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="农村劳务经纪人"
          align="center">
          <el-table-column
            show-overflow-tooltip
            v-for="item in baseInfo3"
            :key="item.key"
            :prop="item.key"
            :label="item.value"
            align="center">
          </el-table-column>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="人力资源服务机构"
          align="center">
          <el-table-column
            show-overflow-tooltip
            v-for="item in baseInfo4"
            :key="item.key"
            :prop="item.key"
            :label="item.value"
            align="center">
          </el-table-column>
        </el-table-column>
      </el-table>
      <paging
          :pagesData="$data.paging_data"
          @set_page_number = 'get_page_number'
      ></paging>
    </div>
  </div>
</template>
<script>
import mixins from '@/Mixins'
export default {
  mixins:[mixins],
  data() {
    return{
      form:{},
      api:'/user/resourceAllowance',
      tableData:[],
      selectRow:[],
      baseInfo1:[
        {key: 'totalAllowanceFee', value: '总金额'},
        {key: 'villageAllowanceFee', value: '农村劳务经纪人'},
        {key: 'resourceAllowanceFee', value: '人力资源服务机构'},
      ],
      baseInfo2:[
        {key: 'allowanceCount', value: '补贴人数'},
        {key: 'villageAllowanceCount', value: '农村劳务经纪人'},
        {key: 'resourceAllowancePersons', value: '人力资源服务机构'},
      ],
      baseInfo3:[
        {key: 'villageCount', value: '经纪人人数'},
        {key: 'villageAllowanceCount', value: '补贴人数'},
      ],
      baseInfo4:[
        {key: 'resourceCount', value: '机构个数'},
        {key: 'resourceAllowanceCount', value: '补贴个数'},
      ],
    }
  },
  created() {
    this.isShowBtn("ResourceAllowanceReport")//控制操作按钮的显示与隐藏
    this.getArea({value:{areaId:0},key:0})
  },
  methods:{
    handleSelectionChange(val) {
      this.selectRow = val
    },
    //分页
    get_page_number(pageNumer) {
      let [vm] = [this]
      vm.form.pageNumber = pageNumer;
      vm.Filter_file({api:vm.api,data:vm.form,callback:_d => vm.tableData = _d})
    },
  }
}
</script>
<style>
/* .index .index-header .el-form-item__content{width: 200px;} */
.input-box>div{display: flex;flex-direction: column;flex-shrink: 0;}
</style>